module.exports = __webpack_public_path__ + "img/como-funciona.a9b03709.gif";